/**
 * InView :
 *   要素が画面に入ったらクラスつける
 */

import * as lazyLoad from '../libs/lazy-load'
import poryfill from '../libs/intersection-observer-poryfill'
poryfill()

class InView {
  constructor() {
    this.inView = document.querySelectorAll('.js-inView,[data-lazy]')
    this.observer = new IntersectionObserver(
      observes => {
        this.observeTarget(observes)
      },
      {
        // 0だと1pxでも画面に入った瞬間にisInterestingになる
        // 1だと全て画面に入ったらisInterestingになる
        threshold: [0.3]
      }
    )
  }

  init() {
    if (!this.inView.length) return
    this.attachEvent()
  }

  attachEvent() {
    ;[...this.inView].forEach(elem => {
      this.observer.observe(elem)
    })
  }

  observeTarget(observes) {
    observes.forEach(observe => {
      if (observe.isIntersecting) {
        observe.target.classList.add('-show')
        this.observer.unobserve(observe.target)

        const lazySrc = observe.target.getAttribute('data-lazy')
        if (lazySrc) {
          lazyLoad.load(observe.target, lazySrc)
        }
        // } else {
        //   observe.target.classList.remove('is-show')
      }
    })
  }
}

export default InView



// WEBPACK FOOTER //
// ./src/script/modules/InView.js